'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _hoistNonReactStatics = require('hoist-non-react-statics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _actions = require('@appbaseio/reactivecore/lib/actions');

var _helper = require('@appbaseio/reactivecore/lib/utils/helper');

var _types = require('@appbaseio/reactivecore/lib/utils/types');

var _types2 = _interopRequireDefault(_types);

var _Pagination = require('./addons/Pagination');

var _Pagination2 = _interopRequireDefault(_Pagination);

var _PoweredBy = require('./addons/PoweredBy');

var _PoweredBy2 = _interopRequireDefault(_PoweredBy);

var _Flex = require('../../styles/Flex');

var _Flex2 = _interopRequireDefault(_Flex);

var _results = require('../../styles/results');

var _utils = require('../../utils');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ReactiveList = function (_Component) {
  _inherits(ReactiveList, _Component);

  function ReactiveList(props) {
    _classCallCheck(this, ReactiveList);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    var currentPage = 0;

    if (_this.props.defaultPage >= 0) {
      currentPage = _this.props.defaultPage;
    } else if (_this.props.currentPage) {
      currentPage = Math.max(_this.props.currentPage - 1, 0);
    }

    _this.initialFrom = currentPage * props.size; // used for page resetting on query change

    _this.state = {
      from: _this.initialFrom,
      currentPage: currentPage
    };
    _this.internalComponent = props.componentId + '__internal';
    _this.sortOptionIndex = _this.props.defaultSortOption ? _this.props.sortOptions.findIndex(function (s) {
      return s.label === _this.props.defaultSortOption;
    }) : 0;
    props.setQueryListener(props.componentId, props.onQueryChange, props.onError);
    return _this;
  }

  ReactiveList.prototype.componentDidMount = function componentDidMount() {
    this.props.addComponent(this.internalComponent);
    this.props.addComponent(this.props.componentId);

    if (this.props.stream) {
      this.props.setStreaming(this.props.componentId, true);
    }

    var options = (0, _helper.getQueryOptions)(this.props);
    options.from = this.state.from;

    if (this.props.sortOptions) {
      var _ref;

      options.sort = [(_ref = {}, _ref[this.props.sortOptions[this.sortOptionIndex].dataField] = {
        order: this.props.sortOptions[this.sortOptionIndex].sortBy
      }, _ref)];
    } else if (this.props.sortBy) {
      var _ref2;

      options.sort = [(_ref2 = {}, _ref2[this.props.dataField] = {
        order: this.props.sortBy
      }, _ref2)];
    } // Override sort query with defaultQuery's sort if defined


    this.defaultQuery = null;

    if (this.props.defaultQuery) {
      this.defaultQuery = this.props.defaultQuery();
      options = _extends({}, options, (0, _helper.getOptionsFromQuery)(this.defaultQuery));
    }

    var _ref3 = this.defaultQuery || {},
        query = _ref3.query; // execute is set to false at the time of mount
    // to avoid firing (multiple) partial queries.
    // Hence we are building the query in parts here
    // and only executing it with setReact() at core


    var execute = false;
    this.props.setQueryOptions(this.props.componentId, options, execute);

    if (this.defaultQuery) {
      this.props.updateQuery({
        componentId: this.internalComponent,
        query: query
      }, execute);
    } else {
      this.props.updateQuery({
        componentId: this.internalComponent,
        query: null
      }, execute);
    } // query will be executed here


    this.setReact(this.props);
    this.domNode = window;

    if (!this.props.pagination) {
      var scrollTarget = this.props.scrollTarget;

      if (scrollTarget) {
        this.domNode = document.getElementById(scrollTarget);
      }

      this.domNode.addEventListener('scroll', this.scrollHandler);
    }
  };

  ReactiveList.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;

    var totalPages = Math.ceil(this.props.total / this.props.size) || 0;

    if (this.props.onData) {
      (0, _helper.checkSomePropChange)(this.props, prevProps, ['hits', 'streamHits'], function () {
        _this2.props.onData(_this2.getAllData());
      });
    }

    if (!(0, _helper.isEqual)(this.props.sortOptions, prevProps.sortOptions) || this.props.sortBy !== prevProps.sortBy || this.props.size !== prevProps.size || !(0, _helper.isEqual)(this.props.dataField, prevProps.dataField) || !(0, _helper.isEqual)(this.props.includeFields, prevProps.includeFields) || !(0, _helper.isEqual)(this.props.excludeFields, prevProps.excludeFields)) {
      var options = (0, _helper.getQueryOptions)(this.props);
      options.from = this.state.from;

      if (this.props.sortOptions) {
        var _ref4;

        options.sort = [(_ref4 = {}, _ref4[this.props.sortOptions[this.sortOptionIndex].dataField] = {
          order: this.props.sortOptions[this.sortOptionIndex].sortBy
        }, _ref4)];
      } else if (this.props.sortBy) {
        var _ref5;

        options.sort = [(_ref5 = {}, _ref5[this.props.dataField] = {
          order: this.props.sortBy
        }, _ref5)];
      }

      this.props.setQueryOptions(this.props.componentId, options, true);
    }

    if (this.props.defaultQuery && !(0, _helper.isEqual)(this.props.defaultQuery(), this.defaultQuery)) {
      var _options = (0, _helper.getQueryOptions)(this.props);

      _options.from = 0;
      this.defaultQuery = this.props.defaultQuery();
      var query = this.defaultQuery.query;
      var queryOptions = (0, _helper.getOptionsFromQuery)(this.defaultQuery);

      if (queryOptions) {
        _options = _extends({}, _options, (0, _helper.getOptionsFromQuery)(this.defaultQuery));
        this.props.setQueryOptions(this.props.componentId, _options, !query);
      }

      this.props.updateQuery({
        componentId: this.internalComponent,
        query: query
      }, true); // reset page because of query change
      // eslint-disable-next-line

      this.setState({
        currentPage: 0,
        from: 0
      }, function () {
        _this2.updatePageURL(0);
      });
    }

    if (this.props.stream !== prevProps.stream) {
      this.props.setStreaming(this.props.componentId, this.props.stream);
    }

    if (!(0, _helper.isEqual)(prevProps.react, this.props.react)) {
      this.setReact(this.props);
    } // called when results are updated


    if (this.props.onResultStats && prevProps.hits !== this.props.hits) {
      this.props.onResultStats(this.stats);
    }

    if (this.props.pagination) {
      // called when page is changed
      if (this.props.isLoading && (this.props.hits || prevProps.hits)) {
        if (this.props.onPageChange) {
          this.props.onPageChange(this.state.currentPage + 1, totalPages);
        } else if (this.props.scrollOnChange && this.props.pagination) {
          this.domNode.scrollTo(0, 0);
        }
      }

      if (this.props.currentPage !== prevProps.currentPage && this.props.currentPage > 0 && this.props.currentPage <= totalPages) {
        this.setPage(this.props.currentPage - 1);
      }
    }

    if (!this.props.pagination) {
      if (this.props.hits && prevProps.hits) {
        if ( // new items are loaded (from: 0)
        this.props.hits.length < prevProps.hits.length || // new items are loaded and 'from' hasn't changed
        this.props.hits.length === prevProps.hits.length && this.props.hits !== prevProps.hits) {
          // query has changed
          if (this.props.scrollOnChange) {
            this.domNode.scrollTo(0, 0);
          } // eslint-disable-next-line


          this.setState({
            from: 0
          });
        }
      }
    }

    if (prevProps.queryLog && this.props.queryLog && prevProps.queryLog !== this.props.queryLog) {
      // usecase:
      // - query has changed from non-null prev query
      if (this.props.queryLog.from !== this.state.from) {
        // query's 'from' key doesn't match the state's 'from' key,
        // i.e. this query change was not triggered by the page change (loadMore)
        // eslint-disable-next-line
        this.setState({
          currentPage: 0
        }, function () {
          _this2.updatePageURL(0);
        });

        if (this.props.onPageChange) {
          this.props.onPageChange(1, totalPages);
        }
      } else if (this.initialFrom && this.initialFrom === this.props.queryLog.from) {
        // [non-zero] initialFrom matches the current query's from
        // but the query has changed
        // we need to update the query options in this case
        // because the initial load had set the query 'from' in the store
        // which is not valid anymore because the query has changed
        var _options2 = (0, _helper.getQueryOptions)(this.props);

        _options2.from = 0;
        this.initialFrom = 0;

        if (this.props.sortOptions) {
          var _ref6;

          _options2.sort = [(_ref6 = {}, _ref6[this.props.sortOptions[this.sortOptionIndex].dataField] = {
            order: this.props.sortOptions[this.sortOptionIndex].sortBy
          }, _ref6)];
        } else if (this.props.sortBy) {
          var _ref7;

          _options2.sort = [(_ref7 = {}, _ref7[this.props.dataField] = {
            order: this.props.sortBy
          }, _ref7)];
        }

        this.props.setQueryOptions(this.props.componentId, _options2, true);
      }
    }

    if (prevProps.pagination !== this.props.pagination) {
      if (this.props.pagination) {
        this.domNode.addEventListener('scroll', this.scrollHandler);
      } else {
        this.domNode.removeEventListener('scroll', this.scrollHandler);
      }
    } // handle window url history change (on native back and forth interactions)


    if (this.state.currentPage !== this.props.defaultPage && this.props.defaultPage !== prevProps.defaultPage) {
      this.setPage(this.props.defaultPage >= 0 ? this.props.defaultPage : 0);
    }
  };

  ReactiveList.prototype.componentWillUnmount = function componentWillUnmount() {
    this.props.removeComponent(this.props.componentId);
    this.props.removeComponent(this.internalComponent);

    if (this.domNode) {
      this.domNode.removeEventListener('scroll', this.scrollHandler);
    }
  }; // Shape of the object to be returned in onData & renderAllData


  ReactiveList.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        renderData = _props.renderData,
        size = _props.size,
        error = _props.error,
        promotedResults = _props.promotedResults;
    var currentPage = this.state.currentPage;
    var allData = this.getAllData();
    var results = allData.results,
        streamResults = allData.streamResults;
    var filteredResults = results;

    if (streamResults.length) {
      var ids = streamResults.map(function (item) {
        return item._id;
      });
      filteredResults = filteredResults.filter(function (item) {
        return !ids.includes(item._id);
      });
    }

    if (promotedResults.length) {
      var _ids = promotedResults.map(function (item) {
        return item._id;
      }).filter(Boolean);

      if (_ids) {
        filteredResults = filteredResults.filter(function (item) {
          return !_ids.includes(item._id);
        });
      }

      filteredResults = [].concat(promotedResults, filteredResults);
    }

    return _react2.default.createElement('div', {
      style: this.props.style,
      className: this.props.className
    }, this.props.isLoading && this.props.pagination && this.props.loader, this.renderError(), _react2.default.createElement(_Flex2.default, {
      labelPosition: this.props.sortOptions ? 'right' : 'left',
      className: (0, _helper.getClassName)(this.props.innerClass, 'resultsInfo')
    }, this.props.sortOptions ? this.renderSortOptions() : null, this.props.showResultStats ? this.renderResultStats() : null), !this.props.isLoading && !error && results.length === 0 && streamResults.length === 0 ? this.renderNoResults() : null, this.props.pagination && (this.props.paginationAt === 'top' || this.props.paginationAt === 'both') ? _react2.default.createElement(_Pagination2.default, {
      pages: this.props.pages,
      totalPages: Math.ceil(this.props.total / this.props.size),
      currentPage: this.state.currentPage,
      setPage: this.setPage,
      innerClass: this.props.innerClass,
      fragmentName: this.props.componentId
    }) : null, this.props.renderAllData ? this.props.renderAllData(allData) : _react2.default.createElement('div', {
      className: this.props.listClass + ' ' + (0, _helper.getClassName)(this.props.innerClass, 'list')
    }, [].concat(streamResults, filteredResults).map(function (item, index) {
      return renderData(item, function () {
        _this3.triggerClickAnalytics(currentPage * size + index);
      });
    })), this.props.isLoading && !this.props.pagination ? this.props.loader || _react2.default.createElement('div', {
      style: {
        textAlign: 'center',
        margin: '20px 0',
        color: '#666'
      }
    }, 'Loading...') // prettier-ignore
    : null, this.props.pagination && (this.props.paginationAt === 'bottom' || this.props.paginationAt === 'both') ? _react2.default.createElement(_Pagination2.default, {
      pages: this.props.pages,
      totalPages: Math.ceil(this.props.total / this.props.size),
      currentPage: this.state.currentPage,
      setPage: this.setPage,
      innerClass: this.props.innerClass,
      fragmentName: this.props.componentId
    }) : null, this.props.config.url.endsWith('appbase.io') && results.length ? _react2.default.createElement(_Flex2.default, {
      direction: 'row-reverse',
      className: (0, _helper.getClassName)(this.props.innerClass, 'poweredBy')
    }, _react2.default.createElement(_PoweredBy2.default, null)) : null);
  };

  _createClass(ReactiveList, [{
    key: 'stats',
    get: function get() {
      var results = (0, _helper.parseHits)(this.props.hits) || [];
      var streamResults = (0, _helper.parseHits)(this.props.streamHits) || [];
      var filteredResults = results;

      if (streamResults.length) {
        var ids = streamResults.map(function (item) {
          return item._id;
        });
        filteredResults = filteredResults.filter(function (item) {
          return !ids.includes(item._id);
        });
      }

      return {
        totalResults: this.props.total,
        totalPages: Math.ceil(this.props.total / this.props.size),
        displayedResults: [].concat(streamResults, filteredResults).length,
        time: this.props.time,
        currentPage: this.state.currentPage
      };
    } // only used for SSR

  }]);

  return ReactiveList;
}(_react.Component);

ReactiveList.generateQueryOptions = function (props) {
  // simulate default (includeFields and excludeFields) props to generate consistent query
  var options = (0, _helper.getQueryOptions)(_extends({
    includeFields: ['*'],
    excludeFields: []
  }, props));
  options.from = props.currentPage ? (props.currentPage - 1) * (props.size || 10) : 0;
  options.size = props.size || 10;

  if (props.sortOptions) {
    var _ref8;

    options.sort = [(_ref8 = {}, _ref8[props.sortOptions[undefined.sortOptionIndex].dataField] = {
      order: props.sortOptions[undefined.sortOptionIndex].sortBy
    }, _ref8)];
  } else if (props.sortBy) {
    var _ref9;

    options.sort = [(_ref9 = {}, _ref9[props.dataField] = {
      order: props.sortBy
    }, _ref9)];
  }

  return options;
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.getAllData = function () {
    var size = _this4.props.size;
    var currentPage = _this4.state.currentPage;
    var results = (0, _helper.parseHits)(_this4.props.hits) || [];
    var streamResults = (0, _helper.parseHits)(_this4.props.streamHits) || [];
    return {
      results: results,
      streamResults: streamResults,
      loadMore: _this4.loadMore,
      base: currentPage * size,
      triggerClickAnalytics: _this4.triggerClickAnalytics
    };
  };

  this.setReact = function (props) {
    var react = props.react;

    if (react) {
      var newReact = (0, _helper.pushToAndClause)(react, _this4.internalComponent);
      props.watchComponent(props.componentId, newReact);
    } else {
      props.watchComponent(props.componentId, {
        and: _this4.internalComponent
      });
    }
  };

  this.scrollHandler = function () {
    var renderLoader = window.innerHeight + window.pageYOffset + 300 >= document.body.offsetHeight;

    if (_this4.props.scrollTarget) {
      renderLoader = _this4.domNode.clientHeight + _this4.domNode.scrollTop + 300 >= _this4.domNode.scrollHeight;
    }

    if (!_this4.props.isLoading && renderLoader) {
      _this4.loadMore();
    }
  };

  this.loadMore = function () {
    if (_this4.props.hits && !_this4.props.pagination && _this4.props.total !== _this4.props.hits.length) {
      var value = _this4.state.from + _this4.props.size;
      var options = (0, _helper.getQueryOptions)(_this4.props);

      _this4.setState({
        from: value
      });

      _this4.props.loadMore(_this4.props.componentId, _extends({}, options, {
        from: value
      }), true);
    }
  };

  this.setPage = function (page) {
    // onPageClick will be called everytime a pagination button is clicked
    if (page !== _this4.state.currentPage) {
      var onPageClick = _this4.props.onPageClick;

      if (onPageClick) {
        onPageClick(page + 1);
      }

      var value = _this4.props.size * page;
      var options = (0, _helper.getQueryOptions)(_this4.props);
      options.from = _this4.state.from;

      _this4.setState({
        from: value,
        currentPage: page
      }, function () {
        _this4.props.loadMore(_this4.props.componentId, _extends({}, options, {
          from: value
        }), false);

        _this4.updatePageURL(page);
      });
    }
  };

  this.renderResultStats = function () {
    if (_this4.props.renderResultStats && _this4.props.total) {
      return _this4.props.renderResultStats(_this4.stats);
    } else if (_this4.props.total) {
      return _react2.default.createElement('p', {
        className: _results.resultStats + ' ' + (0, _helper.getClassName)(_this4.props.innerClass, 'resultStats')
      }, _this4.props.total, ' results found in ', _this4.props.time, 'ms');
    }

    return null;
  };

  this.renderNoResults = function () {
    return _react2.default.createElement('div', {
      className: (0, _helper.getClassName)(_this4.props.innerClass, 'noResults') || null
    }, _this4.props.renderNoResults());
  };

  this.handleSortChange = function (e) {
    var _ref10;

    var index = e.target.value;
    var options = (0, _helper.getQueryOptions)(_this4.props); // This fixes issue #371 (where sorting a multi-result page with infinite loader breaks)

    options.from = 0;
    options.sort = [(_ref10 = {}, _ref10[_this4.props.sortOptions[index].dataField] = {
      order: _this4.props.sortOptions[index].sortBy
    }, _ref10)];

    _this4.props.setQueryOptions(_this4.props.componentId, options, true);

    _this4.setState({
      currentPage: 0,
      from: 0
    }, function () {
      _this4.updatePageURL(0);
    });
  };

  this.updatePageURL = function (page) {
    if (_this4.props.URLParams) {
      _this4.props.setPageURL(_this4.props.componentId, page + 1, _this4.props.componentId, false, true);
    }
  };

  this.triggerClickAnalytics = function (searchPosition) {
    // click analytics would only work client side and after javascript loads
    var _props2 = _this4.props,
        config = _props2.config,
        searchId = _props2.analytics.searchId;
    var url = config.url,
        app = config.app,
        credentials = config.credentials;

    if (config.analytics && searchId) {
      fetch(url + '/' + app + '/_analytics', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Basic ' + btoa(credentials),
          'X-Search-Id': searchId,
          'X-Search-Click': true,
          'X-Search-ClickPosition': searchPosition + 1,
          'X-Search-Conversion': true
        }
      });
    }
  };

  this.renderSortOptions = function () {
    return _react2.default.createElement('select', {
      className: _results.sortOptions + ' ' + (0, _helper.getClassName)(_this4.props.innerClass, 'sortOptions'),
      name: 'sort-options',
      onChange: _this4.handleSortChange,
      defaultValue: _this4.sortOptionIndex
    }, _this4.props.sortOptions.map(function (sort, index) {
      return _react2.default.createElement('option', {
        key: sort.label,
        value: index
      }, sort.label);
    }));
  };

  this.renderError = function () {
    var _props3 = _this4.props,
        error = _props3.error,
        isLoading = _props3.isLoading,
        renderError = _props3.renderError;

    if (renderError && error && !isLoading) {
      return (0, _utils.isFunction)(renderError) ? renderError(error) : renderError;
    }

    return null;
  };
};

ReactiveList.propTypes = {
  addComponent: _types2.default.funcRequired,
  loadMore: _types2.default.funcRequired,
  removeComponent: _types2.default.funcRequired,
  setQueryListener: _types2.default.funcRequired,
  onQueryChange: _types2.default.func,
  onError: _types2.default.func,
  setPageURL: _types2.default.func,
  setQueryOptions: _types2.default.funcRequired,
  setStreaming: _types2.default.func,
  updateQuery: _types2.default.funcRequired,
  watchComponent: _types2.default.funcRequired,
  currentPage: _types2.default.number,
  hits: _types2.default.hits,
  isLoading: _types2.default.bool,
  includeFields: _types2.default.includeFields,
  streamHits: _types2.default.hits,
  promotedResults: _types2.default.hits,
  time: _types2.default.number,
  total: _types2.default.number,
  config: _types2.default.props,
  analytics: _types2.default.props,
  queryLog: _types2.default.props,
  // component props
  className: _types2.default.string,
  componentId: _types2.default.stringRequired,
  dataField: _types2.default.stringRequired,
  defaultPage: _types2.default.number,
  defaultQuery: _types2.default.func,
  error: _types2.default.title,
  excludeFields: _types2.default.excludeFields,
  innerClass: _types2.default.style,
  listClass: _types2.default.string,
  loader: _types2.default.title,
  renderAllData: _types2.default.func,
  renderData: _types2.default.func,
  renderError: _types2.default.title,
  onData: _types2.default.func,
  renderNoResults: _types2.default.title,
  onPageChange: _types2.default.func,
  onPageClick: _types2.default.func,
  onResultStats: _types2.default.func,
  pages: _types2.default.number,
  pagination: _types2.default.bool,
  paginationAt: _types2.default.paginationAt,
  react: _types2.default.react,
  renderResultStats: _types2.default.func,
  scrollOnChange: _types2.default.bool,
  scrollTarget: _types2.default.string,
  showResultStats: _types2.default.bool,
  size: _types2.default.number,
  sortBy: _types2.default.sortBy,
  sortOptions: _types2.default.sortOptions,
  stream: _types2.default.bool,
  style: _types2.default.style,
  URLParams: _types2.default.bool,
  defaultSortOption: _types2.default.string
};
ReactiveList.defaultProps = {
  className: null,
  currentPage: 0,
  listClass: '',
  pages: 5,
  pagination: false,
  paginationAt: 'bottom',
  includeFields: ['*'],
  excludeFields: [],
  showResultStats: true,
  size: 10,
  style: {},
  URLParams: false,
  renderNoResults: function renderNoResults() {
    return 'No Results found.';
  },
  scrollOnChange: true,
  defaultSortOption: null
};

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    defaultPage: state.selectedValues[props.componentId] && state.selectedValues[props.componentId].value - 1 || -1,
    hits: state.hits[props.componentId] && state.hits[props.componentId].hits,
    isLoading: state.isLoading[props.componentId] || false,
    streamHits: state.streamHits[props.componentId],
    time: state.hits[props.componentId] && state.hits[props.componentId].time || 0,
    total: state.hits[props.componentId] && state.hits[props.componentId].total,
    analytics: state.analytics,
    config: state.config,
    queryLog: state.queryLog[props.componentId],
    error: state.error[props.componentId],
    promotedResults: state.promotedResults
  };
};

var mapDispatchtoProps = function mapDispatchtoProps(dispatch) {
  return {
    addComponent: function addComponent(component) {
      return dispatch((0, _actions.addComponent)(component));
    },
    loadMore: function loadMore(component, options, append) {
      return dispatch((0, _actions.loadMore)(component, options, append));
    },
    removeComponent: function removeComponent(component) {
      return dispatch((0, _actions.removeComponent)(component));
    },
    setPageURL: function setPageURL(component, value, label, showFilter, URLParams) {
      return dispatch((0, _actions.setValue)(component, value, label, showFilter, URLParams));
    },
    setQueryOptions: function setQueryOptions(component, props, execute) {
      return dispatch((0, _actions.setQueryOptions)(component, props, execute));
    },
    setQueryListener: function setQueryListener(component, onQueryChange, beforeQueryChange) {
      return dispatch((0, _actions.setQueryListener)(component, onQueryChange, beforeQueryChange));
    },
    setStreaming: function setStreaming(component, stream) {
      return dispatch((0, _actions.setStreaming)(component, stream));
    },
    updateQuery: function updateQuery(updateQueryObject, execute) {
      return dispatch((0, _actions.updateQuery)(updateQueryObject, execute));
    },
    watchComponent: function watchComponent(component, react) {
      return dispatch((0, _actions.watchComponent)(component, react));
    }
  };
};

var ConnectedComponent = (0, _utils.connect)(mapStateToProps, mapDispatchtoProps)(function (props) {
  return _react2.default.createElement(ReactiveList, _extends({
    ref: props.myForwardedRef
  }, props));
}); // eslint-disable-next-line

var ForwardRefComponent = _react2.default.forwardRef(function (props, ref) {
  return _react2.default.createElement(ConnectedComponent, _extends({}, props, {
    myForwardedRef: ref
  }));
});

(0, _hoistNonReactStatics2.default)(ForwardRefComponent, ReactiveList);
ForwardRefComponent.name = 'ReactiveList';
exports.default = ForwardRefComponent;